// extracted by mini-css-extract-plugin
export default {"page":"styles_page__hdw-Z","content":"styles_content__z2aGc"};